import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "circle-crossmark-thin_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10Zm-5.45-3.803-1.104-1.103-3.55 3.55-3.55-3.55-1.104 1.103 3.55 3.55-3.846 3.847 1.103 1.103 3.847-3.846 3.846 3.846 1.103-1.103L13 11.747l3.55-3.55Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }